module.exports = __webpack_public_path__ + "media/recipes/61-f050893e.png";